"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BubbleChartDescriptor = void 0;
var tslib_1 = require("tslib");
var PluggableBubbleChart_1 = require("./PluggableBubbleChart");
var BigChartDescriptor_1 = require("../BigChartDescriptor");
var BubbleChartDescriptor = /** @class */ (function (_super) {
    tslib_1.__extends(BubbleChartDescriptor, _super);
    function BubbleChartDescriptor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BubbleChartDescriptor.prototype.getFactory = function () {
        return function (params) { return new PluggableBubbleChart_1.PluggableBubbleChart(params); };
    };
    return BubbleChartDescriptor;
}(BigChartDescriptor_1.BigChartDescriptor));
exports.BubbleChartDescriptor = BubbleChartDescriptor;
//# sourceMappingURL=BubbleChartDescriptor.js.map